import { useMemo } from 'react';
import { endpoints, fetcherSwr } from '../utils/axios';
import useSWR from 'swr';

const pickList = (data) => {
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.data?.devices)) return data.data.devices;
  if (Array.isArray(data?.devices)) return data.devices;
  return [];
};

export function useGetDevices(args = {}) {
  const URL = [endpoints.devices.getDevices, { params: args }];

  const { data, isLoading, error, isValidating, mutate } = useSWR(URL, fetcherSwr);

  return useMemo(
    () => ({
      devices: pickList(data),
      pagination: data?.pagination || data?.data?.pagination || null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );
}



